import sockets from "../../core/sockets";
import io from "socket.io-client";

class Socket {
  constructor(Authentication) {
    const token = Authentication.getValue("token");

    this.options = { query: { socketToken: token }, transports: ["websocket"] };
  }

  customer() {
    return io(sockets.customer, this.options);
  }

  dashboard() {
    return io(sockets.dashboard, this.options);
  }
}

export default Socket;



// WEBPACK FOOTER //
// ./src/services/socket/socket.service.js